


// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';

// const specialties = [
//   {
//     id: 1,
//     title: 'Period doubts or Pregnancy',
//     link: '/doctors?specialty=Gynecologist',
//     image: 'https://www.practostatic.com/consult/consult-home/symptoms_icon/irregular-painful+period.png'
//   },
//   {
//     id: 2,
//     title: 'Acne, pimple or skin issues',
//     link: '/doctors?specialty=Dermatologist',
//     image: 'https://www.practostatic.com/consult/consult-home/symptoms_icon/Acne.png'
//   },
//   {
//     id: 3,
//     title: 'Cold, cough or fever',
//     link: '/doctors?specialty=Pediatrician',
//     image: 'https://www.practostatic.com/consult/consult-home/symptoms_icon/coughing.png'
//   },
//   {
//     id: 4,
//     title: 'Child not feeling well',
//     link: '/doctors?specialty=Pediatrician',
//     image: 'https://www.practo.com/consult/static/images/top-speciality-pediatric.svg'
//   },
//   {
//     id: 5,
//     title: 'Depression or anxiety',
//     link: '/doctors?specialty=Psychiatrist',
//     image: 'https://www.practostatic.com/acred/search-assets/2/12-mental-wellness.png'
//   }
// ];

// const appointmentCards = [
//   {
//     id: 1,
//     title: 'Dentist',
//     description: 'Teething troubles? Schedule a dental checkup',
//     link: '/doctors?specialty=Dentist',
//     image: '/images/5.png'
//   },
//   {
//     id: 2,
//     title: 'Cardiologist',
//     description: 'Expert heart care and cardiovascular specialists',
//     link: '/doctors?specialty=Cardiologist',
//     image: '/images/6.png'
//   },
//   {
//     id: 3,
//     title: 'Gynaecologist',
//     description: "Explore for women's health, pregnancy and infertility treatments",
//     link: '/doctors?specialty=Gynecologist',
//     image: '/images/7.png'
//   },
//   {
//     id: 4,
//     title: 'Neurologist',
//     description: 'Brain and nervous system experts near you',
//     link: '/doctors?specialty=Neurologist',
//     image: '/images/8.png'
//   }
// ];

// const Homepage = () => {
//   const [searchQuery, setSearchQuery] = useState('');
//   const [location, setLocation] = useState('');

//   const popularSearches = [
//     { label: 'Dermatologist', specialty: 'Dermatologist' },
//     { label: 'Pediatrician', specialty: 'Pediatrician' },
//     { label: 'Gynecologist', specialty: 'Gynecologist' },
//     { label: 'Dentist', specialty: 'Dentist' },
//     { label: 'Cardiologist', specialty: 'Cardiologist' },
//     { label: 'Neurologist', specialty: 'Neurologist' },
//     { label: 'Psychiatrist', specialty: 'Psychiatrist' },
//   ];

//   const handleSearch = () => {
//     const params = new URLSearchParams();
//     if (searchQuery) params.set('search', searchQuery);
//     if (location) params.set('city', location);
//     window.location.href = `/doctors?${params.toString()}`;
//   };

//   const handleKeyDown = (e) => {
//     if (e.key === 'Enter') handleSearch();
//   };

//   const cards = [
//     {
//       id: 1,
//       title: 'Find Doctors Near You',
//       subtitle: 'Confirmed appointments',
//       image: '/images/2.png',
//       bg: '#cffafe',
//       link: '/doctors',
//       fitStyle: 'object-contain'
//     },
//     {
//       id: 2,
//       title: 'Lab Tests',
//       subtitle: 'Safe and trusted lab tests',
//       image: '/images/3.png',
//       bg: '#e9d5ff',
//       link: '/lab-tests',
//       fitStyle: 'object-cover object-top'
//     },
//     {
//       id: 3,
//       title: 'Health Packages',
//       subtitle: 'Comprehensive health checkups',
//       image: '/images/4.png',
//       bg: '#d1fae5',
//       link: '/health-packages',
//       fitStyle: 'object-cover object-top'
//     },
//     {
//       id: 4,
//       title: 'Video Consult',
//       subtitle: 'Coming soon — stay tuned',
//       image: '/images/1.png',
//       bg: '#dbeafe',
//       link: '#',
//       fitStyle: 'object-contain',
//       comingSoon: true
//     },
//   ];

//   return (
//     <div className="min-h-screen bg-white">

//       {/* ── HERO SECTION ── */}
//       <div style={{
//         background: 'linear-gradient(135deg, #19354a 0%, #1e4d6b 60%, #1a3f5c 100%)',
//         padding: '72px 24px 80px',
//         textAlign: 'center',
//         position: 'relative',
//         overflow: 'hidden',
//       }}>
//         <div style={{ position:'absolute', top:-60, left:-60, width:200, height:200, borderRadius:'50%', background:'rgba(57,165,211,0.08)' }} />
//         <div style={{ position:'absolute', bottom:-40, right:-40, width:160, height:160, borderRadius:'50%', background:'rgba(57,165,211,0.06)' }} />

//         <p style={{ color:'#39a5d3', fontSize:13, fontWeight:700, letterSpacing:2, textTransform:'uppercase', marginBottom:14, position:'relative' }}>
//           Your Home for Health
//         </p>
//         <h1 style={{ color:'#fff', fontSize:46, fontWeight:800, lineHeight:1.15, marginBottom:10, position:'relative' }}>
//           Find and Book
//         </h1>
//         <p style={{ color:'rgba(255,255,255,0.65)', fontSize:15, marginBottom:40, position:'relative' }}>
//           Verified doctors across India — confirmed appointments, no booking fee
//         </p>

//         {/* Search Bar */}
//         <div style={{ maxWidth:700, margin:'0 auto 28px', position:'relative', zIndex:2 }}>
//           <div style={{ display:'flex', background:'#fff', borderRadius:12, boxShadow:'0 8px 32px rgba(0,0,0,0.25)', overflow:'hidden' }}>
//             <div style={{ display:'flex', alignItems:'center', borderRight:'1px solid #e5e7eb', padding:'0 16px', minWidth:180, gap:8 }}>
//               <svg width="16" height="16" fill="none" stroke="#9ca3af" strokeWidth="2" viewBox="0 0 24 24" style={{ flexShrink:0 }}>
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
//               </svg>
//               <input
//                 type="text"
//                 value={location}
//                 onChange={(e) => setLocation(e.target.value)}
//                 onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
//                 placeholder="City"
//                 style={{ border:'none', outline:'none', fontSize:15, color:'#374151', background:'transparent', width:'100%', padding:'16px 0' }}
//               />
//             </div>
//             <div style={{ display:'flex', alignItems:'center', flex:1, padding:'0 16px', gap:8 }}>
//               <svg width="16" height="16" fill="none" stroke="#9ca3af" strokeWidth="2" viewBox="0 0 24 24" style={{ flexShrink:0 }}>
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//               </svg>
//               <input
//                 type="text"
//                 value={searchQuery}
//                 onChange={(e) => setSearchQuery(e.target.value)}
//                 onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
//                 placeholder="Search doctors, specialties, clinics..."
//                 style={{ border:'none', outline:'none', fontSize:15, color:'#374151', background:'transparent', width:'100%', padding:'16px 0' }}
//               />
//             </div>
//             <button
//               onClick={handleSearch}
//               style={{ background:'#39a5d3', color:'#fff', border:'none', padding:'0 28px', fontSize:15, fontWeight:700, cursor:'pointer', fontFamily:'inherit', whiteSpace:'nowrap' }}
//             >
//               Search
//             </button>
//           </div>
//         </div>

//         {/* Popular Searches */}
//         <div style={{ position:'relative', zIndex:2 }}>
//           <span style={{ color:'rgba(255,255,255,0.55)', fontSize:13, marginRight:10 }}>Popular searches:</span>
//           {[
//             { label:'Dermatologist', specialty:'Dermatologist' },
//             { label:'Pediatrician', specialty:'Pediatrician' },
//             { label:'Gynecologist', specialty:'Gynecologist' },
//             { label:'Dentist', specialty:'Dentist' },
//             { label:'Cardiologist', specialty:'Cardiologist' },
//             { label:'Neurologist', specialty:'Neurologist' },
//             { label:'Psychiatrist', specialty:'Psychiatrist' },
//           ].map(item => (
//             <Link
//               key={item.specialty}
//               to={`/doctors?specialty=${item.specialty}`}
//               style={{
//                 display:'inline-block', color:'rgba(255,255,255,0.85)', fontSize:13, fontWeight:500,
//                 padding:'5px 14px', border:'1px solid rgba(255,255,255,0.2)', borderRadius:20,
//                 marginRight:8, marginBottom:8, textDecoration:'none',
//                 background:'rgba(255,255,255,0.08)',
//               }}
//             >
//               {item.label}
//             </Link>
//           ))}
//         </div>
//       </div>

      
//       {/* ── VIDEO SECTION ── */}
//       <div className="max-w-6xl mx-auto px-6 mt-12">
//         <div className="flex flex-col md:flex-row items-center gap-10">

//           {/* Left: Phone mockup with video inside */}
//           <div className="md:w-1/2 flex justify-center">
//             <div className="relative" style={{ width: 200 }}>
//               {/* Phone frame */}
//               <div style={{
//                 border: '8px solid #1a1a1a',
//                 borderRadius: 30,
//                 overflow: 'hidden',
//                 boxShadow: '0 20px 50px rgba(0,0,0,0.15)',
//                 background: '#000',
//                 position: 'relative',
//               }}>
//                 {/* Notch */}
//                 <div style={{
//                   position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)',
//                   width: 55, height: 16, background: '#1a1a1a', borderRadius: '0 0 12px 12px', zIndex: 10
//                 }} />
//                 {/* Video */}
//                 <video
//                   src="/images/video.mp4"
//                   autoPlay
//                   muted
//                   loop
//                   playsInline
//                   style={{ width: '100%', height: 360, objectFit: 'cover', display: 'block' }}
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Right: Content */}
//           <div className="md:w-1/2">
//             <h2 style={{ fontSize: 26, fontWeight: 700, color: '#111', lineHeight: 1.2, marginBottom: 12 }}>
//               Skip the long wait.<br />
//               <span style={{ color: '#19354a' }}>Book a doctor today.</span>
//             </h2>

//             <p style={{ fontSize: 14, color: '#555', lineHeight: 1.7, marginBottom: 20 }}>
//               Docmize makes it easy to find verified, experienced doctors near you —
//               compare specialties, check availability, and book a confirmed clinic appointment in minutes.
//             </p>

//             <div className="flex flex-col gap-2 mb-6">
//               {[
//                 { bold: '25+ verified doctors', rest: ' across top specialties' },
//                 { bold: 'Confirmed appointments', rest: ' — no wait, no confusion' },
//                 { bold: 'No booking fee', rest: ' — pay only at the clinic' },
//                 { bold: 'Available in', rest: ' Bangalore, Delhi, Mumbai & more' },
//               ].map((point) => (
//                 <div key={point.bold} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
//                   <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
//                     <path d="M3 9l4 4 8-8" stroke="#39a5d3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//                   </svg>
//                   <span style={{ fontSize: 14, color: '#333' }}>
//                     <strong>{point.bold}</strong>{point.rest}
//                   </span>
//                 </div>
//               ))}
//             </div>

//             <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
//               <Link
//                 to="/doctors"
//                 style={{ padding: '12px 28px', background: '#39a5d3', color: '#fff', borderRadius: 8, fontWeight: 600, fontSize: 14, textDecoration: 'none' }}
//               >
//                 Find a Doctor
//               </Link>
//               <Link
//                 to="/doctors"
//                 style={{ padding: '12px 28px', border: '1.5px solid #19354a', color: '#19354a', borderRadius: 8, fontWeight: 600, fontSize: 14, textDecoration: 'none', background: 'transparent' }}
//               >
//                 Browse Specialties
//               </Link>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* ── Consult top doctors section ── */}
//       <div className="max-w-6xl mx-auto px-6 mt-20">
//         <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between mb-10">
//           <div>
//             <h2 className="text-2xl font-bold text-gray-900">Find the right doctor for any health concern</h2>
//             <p className="text-sm text-gray-500 mt-1">Book confirmed in-clinic appointments with verified specialists</p>
//           </div>
//           <Link
//             to="/doctors"
//             className="mt-4 sm:mt-0 inline-block border border-[#4CAFD6] text-[#4CAFD6] text-sm font-semibold px-5 py-2 rounded-md hover:bg-[#4CAFD6] hover:text-white transition-colors whitespace-nowrap"
//           >
//             View All Specialties
//           </Link>
//         </div>

//         <div className="grid grid-cols-3 sm:grid-cols-5 gap-6">
//           {specialties.map((item) => (
//             <Link key={item.id} to={item.link} className="flex flex-col items-center text-center group">
//               <div className="w-28 h-28 mb-3 group-hover:scale-105 transition-transform flex items-center justify-center">
//                 <img
//                   src={item.image}
//                   alt={item.title}
//                   className="w-full h-full object-contain"
//                   onError={(e) => { e.target.style.display = 'none'; }}
//                 />
//               </div>
//               <p className="text-sm font-semibold text-gray-800 leading-snug">{item.title}</p>
//               <span className="text-xs font-bold text-[#4CAFD6] mt-1 hover:underline cursor-pointer">BOOK NOW</span>
//             </Link>
//           ))}
//         </div>
//       </div>

//       {/* ── Book an appointment section ── */}
//       <div className="max-w-7xl mx-auto px-6 mt-20 pb-16">
//         <h2 className="text-2xl font-bold text-gray-900">Book an appointment for an in-clinic consultation</h2>
//         <p className="text-sm text-gray-500 mt-1 mb-8">Find experienced doctors across all specialties</p>

//         <div className="grid grid-cols-4 gap-5">
//           {appointmentCards.map((card) => (
//             <Link
//               key={card.id}
//               to={card.link}
//               className="bg-white border border-gray-200 rounded-xl overflow-hidden hover:shadow-lg transition-shadow block"
//             >
//               <div className="w-full overflow-hidden" style={{ height: '220px' }}>
//                 <img
//                   src={card.image}
//                   alt={card.title}
//                   className="w-full h-full object-cover"
//                   onError={(e) => { e.target.style.display = 'none'; }}
//                 />
//               </div>
//               <div className="p-4">
//                 <h3 className="font-bold text-base text-gray-900 mb-1">{card.title}</h3>
//                 <p className="text-sm text-gray-500 leading-snug">{card.description}</p>
//               </div>
//             </Link>
//           ))}
//         </div>
//       </div>

//       {/* ── BLOG SECTION ── */}
//       <div className="max-w-6xl mx-auto px-6 mt-20">
//         <div className="flex gap-12 items-start">

//           {/* Left: Heading */}
//           <div style={{ minWidth: 260, maxWidth: 300 }}>
//             <h2 style={{ fontSize: 28, fontWeight: 700, color: '#111', lineHeight: 1.3, marginBottom: 14 }}>
//               Read top articles from health experts
//             </h2>
//             <p style={{ fontSize: 14, color: '#888', lineHeight: 1.7, marginBottom: 28 }}>
//               Health articles that keep you informed about good health practices and help you achieve your goals.
//             </p>
//             <Link
//               to="/blog"
//               style={{ display: 'inline-block', background: '#39a5d3', color: '#fff', padding: '12px 28px', borderRadius: 8, fontSize: 14, fontWeight: 600, textDecoration: 'none' }}
//             >
//               See all articles
//             </Link>
//           </div>

//           {/* Right: 2 Blog Cards */}
//           <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24, flex: 1 }}>
//             {[
//               {
//                 category: 'PREVENTIVE CARE',
//                 title: 'How to Choose the Right Doctor for Your Health Needs',
//                 author: 'Dr. Anjali Rao',
//                 image: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=600&q=80',
//                 link: '/blog/preventive-care',
//               },
//               {
//                 category: 'HEALTHY LIVING',
//                 title: '10 Simple Habits That Keep You Healthy All Year Round',
//                 author: 'Dr. Sunita Krishnamurthy',
//                 image: 'https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=600&q=80',
//                 link: '/blog/healthy-habits',
//               },
//             ].map((blog, i) => (
//               <Link key={i} to={blog.link} style={{ textDecoration: 'none', display: 'block', border: '1px solid #eee', borderRadius: 12, overflow: 'hidden', background: '#fff', transition: 'box-shadow 0.2s' }}
//                 onMouseEnter={e => e.currentTarget.style.boxShadow = '0 6px 24px rgba(0,0,0,0.08)'}
//                 onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
//               >
//                 {/* Image */}
//                 <div style={{ height: 180, background: '#f0f4f8', overflow: 'hidden' }}>
//                   <img
//                     src={blog.image}
//                     alt={blog.title}
//                     style={{ width: '100%', height: '100%', objectFit: 'cover' }}
//                     onError={e => { e.target.style.display = 'none'; }}
//                   />
//                 </div>
//                 {/* Text */}
//                 <div style={{ padding: '16px 18px 20px' }}>
//                   <p style={{ fontSize: 11, fontWeight: 700, color: '#39a5d3', letterSpacing: 0.8, marginBottom: 8 }}>
//                     {blog.category}
//                   </p>
//                   <h3 style={{ fontSize: 15, fontWeight: 600, color: '#19354a', lineHeight: 1.4, marginBottom: 12 }}>
//                     {blog.title}
//                   </h3>
//                   <p style={{ fontSize: 12, color: '#888', margin: 0 }}>{blog.author}</p>
//                 </div>
//               </Link>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* ── CARE BANNER ── */}
//       <div style={{ maxWidth: 1200, margin: '64px auto 64px', padding: '0 24px' }}>
//         <div style={{
//           background: 'linear-gradient(135deg, #1a3faa 0%, #2756d6 50%, #1e4fc2 100%)',
//           borderRadius: 16, overflow: 'hidden', position: 'relative',
//           minHeight: 260, display: 'flex', alignItems: 'center',
//         }}>
//           {/* Left: Text */}
//           <div style={{ flex: 1, padding: '44px 52px', zIndex: 2, position: 'relative' }}>
//             <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginBottom: 16 }}>
//               <span style={{ color: '#fff', fontWeight: 700, fontSize: 15, letterSpacing: 0.5 }}>Docmize</span>
//               <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: 13, margin: '0 2px' }}>·</span>
//               <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: 13 }}>Partner Clinics</span>
//             </div>

//             <h2 style={{ color: '#fff', fontSize: 28, fontWeight: 700, lineHeight: 1.3, marginBottom: 10, maxWidth: 460 }}>
//               End-to-end care from verified doctors<br />at our partner clinics
//             </h2>

//             <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: 14, lineHeight: 1.7, marginBottom: 26, maxWidth: 420 }}>
//               Talk to our team today to find the right doctor for your needs.<br />
//               Confirmed appointments, no booking fee, trusted clinics.
//             </p>

//             <a href="tel:+918920845297" style={{
//               display: 'inline-flex', alignItems: 'center', gap: 10,
//               border: '1.5px solid rgba(255,255,255,0.8)', color: '#fff', borderRadius: 8,
//               padding: '10px 22px', fontSize: 14, fontWeight: 600,
//               textDecoration: 'none', background: 'rgba(255,255,255,0.12)',
//             }}>
//               <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 7V5z" />
//               </svg>
//               Reach out to us on &nbsp;|&nbsp; +91 89208 45297
//             </a>
//           </div>

//           {/* Right: Doctor image blended into blue bg */}
//           <div style={{
//             position: 'absolute', right: 0, bottom: 0,
//             height: '100%', width: '38%',
//           }}>
//             {/* Left fade so image blends into banner */}
//             <div style={{
//               position: 'absolute', left: 0, top: 0, bottom: 0, width: 180,
//               background: 'linear-gradient(to right, #2756d6, transparent)', zIndex: 1,
//             }} />
//             {/* Top fade to remove white top edge */}
//             <div style={{
//               position: 'absolute', top: 0, left: 0, right: 0, height: 60,
//               background: 'linear-gradient(to bottom, #2756d6, transparent)', zIndex: 1,
//             }} />
//             {/* Right fade to remove white right edge */}
//             <div style={{
//               position: 'absolute', right: 0, top: 0, bottom: 0, width: 60,
//               background: 'linear-gradient(to left, #1e4fc2, transparent)', zIndex: 1,
//             }} />
//             {/* Bottom fade */}
//             <div style={{
//               position: 'absolute', bottom: 0, left: 0, right: 0, height: 60,
//               background: 'linear-gradient(to top, #1e4fc2, transparent)', zIndex: 1,
//             }} />
//             <img
//               src="/images/9.png"
//               alt="Doctor"
//               style={{
//                 height: '100%', width: '100%',
//                 objectFit: 'cover', objectPosition: 'top center',
//                 mixBlendMode: 'normal',
//               }}
//             />
//           </div>
//         </div>
//       </div>

//     </div>
//   );
// };

// export default Homepage;

import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const specialties = [
  { id: 1, title: 'Period doubts or Pregnancy', link: '/doctors?specialty=Gynecologist', image: 'https://www.practostatic.com/consult/consult-home/symptoms_icon/irregular-painful+period.png' },
  { id: 2, title: 'Acne, pimple or skin issues', link: '/doctors?specialty=Dermatologist', image: 'https://www.practostatic.com/consult/consult-home/symptoms_icon/Acne.png' },
  { id: 3, title: 'Cold, cough or fever', link: '/doctors?specialty=Pediatrician', image: 'https://www.practostatic.com/consult/consult-home/symptoms_icon/coughing.png' },
  { id: 4, title: 'Child not feeling well', link: '/doctors?specialty=Pediatrician', image: 'https://www.practo.com/consult/static/images/top-speciality-pediatric.svg' },
  { id: 5, title: 'Depression or anxiety', link: '/doctors?specialty=Psychiatrist', image: 'https://www.practostatic.com/acred/search-assets/2/12-mental-wellness.png' },
];

const appointmentCards = [
  { id: 1, title: 'Dentist', description: 'Teething troubles? Schedule a dental checkup', link: '/doctors?specialty=Dentist', image: '/images/5.png' },
  { id: 2, title: 'Cardiologist', description: 'Expert heart care and cardiovascular specialists', link: '/doctors?specialty=Cardiologist', image: '/images/6.png' },
  { id: 3, title: 'Gynaecologist', description: "Explore for women's health, pregnancy and infertility treatments", link: '/doctors?specialty=Gynecologist', image: '/images/7.png' },
  { id: 4, title: 'Neurologist', description: 'Brain and nervous system experts near you', link: '/doctors?specialty=Neurologist', image: '/images/8.png' },
];

const mobileCSS = `
  @media (max-width: 768px) {
    .hero-title { font-size: 30px !important; }
    .hero-sub { font-size: 13px !important; }
    .search-bar-wrap { flex-direction: column !important; border-radius: 10px !important; }
    .search-location { border-right: none !important; border-bottom: 1px solid #e5e7eb !important; min-width: unset !important; width: 100% !important; }
    .search-query { width: 100% !important; }
    .search-btn { width: 100% !important; padding: 14px !important; border-radius: 0 0 10px 10px !important; }
    .video-section { flex-direction: column !important; }
    .video-section .phone-wrap { width: 100% !important; }
    .video-section .content-wrap { width: 100% !important; }
    .specialties-grid { grid-template-columns: repeat(3, 1fr) !important; gap: 16px !important; }
    .appt-grid { grid-template-columns: repeat(2, 1fr) !important; gap: 12px !important; }
    .blog-section { flex-direction: column !important; gap: 24px !important; }
    .blog-grid { grid-template-columns: 1fr !important; }
    .for-doctors-section { flex-direction: column !important; }
    .for-doctors-img { width: 100% !important; height: 220px !important; }
    .banner-text { padding: 28px 20px !important; }
    .banner-title { font-size: 20px !important; }
    .banner-img-col { display: none !important; }
    .popular-tags { display: flex; flex-wrap: wrap; gap: 6px; justify-content: center; }
  }
`;

const Homepage = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [location, setLocation] = useState('');

  const handleSearch = () => {
    const params = new URLSearchParams();
    if (searchQuery) params.set('search', searchQuery);
    if (location) params.set('city', location);
    window.location.href = `/doctors?${params.toString()}`;
  };

  return (
    <div style={{ minHeight: '100vh', background: '#fff', fontFamily: "'Segoe UI', sans-serif" }}>
      <style>{mobileCSS}</style>

      {/* ── HERO ── */}
      <div style={{ background: 'linear-gradient(135deg, #19354a 0%, #1e4d6b 60%, #1a3f5c 100%)', padding: '72px 24px 80px', textAlign: 'center', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: -60, left: -60, width: 200, height: 200, borderRadius: '50%', background: 'rgba(57,165,211,0.08)' }} />
        <div style={{ position: 'absolute', bottom: -40, right: -40, width: 160, height: 160, borderRadius: '50%', background: 'rgba(57,165,211,0.06)' }} />
        <p style={{ color: '#39a5d3', fontSize: 13, fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 14, position: 'relative' }}>Your Home for Health</p>
        <h1 className="hero-title" style={{ color: '#fff', fontSize: 46, fontWeight: 800, lineHeight: 1.15, marginBottom: 10, position: 'relative' }}>Find and Book</h1>
        <p className="hero-sub" style={{ color: 'rgba(255,255,255,0.65)', fontSize: 15, marginBottom: 40, position: 'relative' }}>Verified doctors across India — confirmed appointments, no booking fee</p>

        {/* Search Bar */}
        <div style={{ maxWidth: 700, margin: '0 auto 28px', position: 'relative', zIndex: 2 }}>
          <div className="search-bar-wrap" style={{ display: 'flex', background: '#fff', borderRadius: 12, boxShadow: '0 8px 32px rgba(0,0,0,0.25)', overflow: 'hidden' }}>
            <div className="search-location" style={{ display: 'flex', alignItems: 'center', borderRight: '1px solid #e5e7eb', padding: '0 16px', minWidth: 180, gap: 8 }}>
              <svg width="16" height="16" fill="none" stroke="#9ca3af" strokeWidth="2" viewBox="0 0 24 24" style={{ flexShrink: 0 }}><path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
              <input type="text" value={location} onChange={e => setLocation(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleSearch()} placeholder="City" style={{ border: 'none', outline: 'none', fontSize: 15, color: '#374151', background: 'transparent', width: '100%', padding: '16px 0' }} />
            </div>
            <div className="search-query" style={{ display: 'flex', alignItems: 'center', flex: 1, padding: '0 16px', gap: 8 }}>
              <svg width="16" height="16" fill="none" stroke="#9ca3af" strokeWidth="2" viewBox="0 0 24 24" style={{ flexShrink: 0 }}><path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
              <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleSearch()} placeholder="Search doctors, specialties, clinics..." style={{ border: 'none', outline: 'none', fontSize: 15, color: '#374151', background: 'transparent', width: '100%', padding: '16px 0' }} />
            </div>
            <button className="search-btn" onClick={handleSearch} style={{ background: '#39a5d3', color: '#fff', border: 'none', padding: '0 28px', fontSize: 15, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap' }}>Search</button>
          </div>
        </div>

        {/* Popular Searches */}
        <div className="popular-tags" style={{ position: 'relative', zIndex: 2 }}>
          <span style={{ color: 'rgba(255,255,255,0.55)', fontSize: 13, marginRight: 10 }}>Popular:</span>
          {['Dermatologist','Pediatrician','Gynecologist','Dentist','Cardiologist','Psychiatrist'].map(item => (
            <Link key={item} to={`/doctors?specialty=${item}`} style={{ display: 'inline-block', color: 'rgba(255,255,255,0.85)', fontSize: 13, fontWeight: 500, padding: '5px 14px', border: '1px solid rgba(255,255,255,0.2)', borderRadius: 20, marginRight: 8, marginBottom: 8, textDecoration: 'none', background: 'rgba(255,255,255,0.08)' }}>{item}</Link>
          ))}
        </div>
      </div>

      {/* ── VIDEO SECTION ── */}
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '48px 24px 0' }}>
        <div className="video-section" style={{ display: 'flex', alignItems: 'center', gap: 40 }}>
          <div className="phone-wrap" style={{ width: '45%', display: 'flex', justifyContent: 'center', flexShrink: 0 }}>
            <div style={{ width: 200 }}>
              <div style={{ border: '8px solid #1a1a1a', borderRadius: 30, overflow: 'hidden', boxShadow: '0 20px 50px rgba(0,0,0,0.15)', background: '#000', position: 'relative' }}>
                <div style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', width: 55, height: 16, background: '#1a1a1a', borderRadius: '0 0 12px 12px', zIndex: 10 }} />
                <video src="/images/video.mp4" autoPlay muted loop playsInline style={{ width: '100%', height: 360, objectFit: 'cover', display: 'block' }} />
              </div>
            </div>
          </div>
          <div className="content-wrap" style={{ flex: 1 }}>
            <h2 style={{ fontSize: 26, fontWeight: 700, color: '#111', lineHeight: 1.2, marginBottom: 12 }}>Skip the long wait.<br /><span style={{ color: '#19354a' }}>Book a doctor today.</span></h2>
            <p style={{ fontSize: 14, color: '#555', lineHeight: 1.7, marginBottom: 20 }}>Docmize makes it easy to find verified, experienced doctors near you — compare specialties, check availability, and book a confirmed clinic appointment in minutes.</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 24 }}>
              {[{ bold: '25+ verified doctors', rest: ' across top specialties' }, { bold: 'Confirmed appointments', rest: ' — no wait, no confusion' }, { bold: 'No booking fee', rest: ' — pay only at the clinic' }, { bold: 'Available in', rest: ' Gurgaon, Delhi, Lucknow & more' }].map(p => (
                <div key={p.bold} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M3 9l4 4 8-8" stroke="#39a5d3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                  <span style={{ fontSize: 14, color: '#333' }}><strong>{p.bold}</strong>{p.rest}</span>
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              <Link to="/doctors" style={{ padding: '12px 28px', background: '#39a5d3', color: '#fff', borderRadius: 8, fontWeight: 600, fontSize: 14, textDecoration: 'none' }}>Find a Doctor</Link>
              <Link to="/doctors" style={{ padding: '12px 28px', border: '1.5px solid #19354a', color: '#19354a', borderRadius: 8, fontWeight: 600, fontSize: 14, textDecoration: 'none', background: 'transparent' }}>Browse Specialties</Link>
            </div>
          </div>
        </div>
      </div>

      {/* ── SPECIALTIES ── */}
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '64px 24px 0' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 36, gap: 12 }}>
          <div>
            <h2 style={{ fontSize: 22, fontWeight: 700, color: '#111', margin: '0 0 6px' }}>Find the right doctor for any health concern</h2>
            <p style={{ fontSize: 13, color: '#888', margin: 0 }}>Book confirmed in-clinic appointments with verified specialists</p>
          </div>
          <Link to="/doctors" style={{ display: 'inline-block', border: '1px solid #39a5d3', color: '#39a5d3', fontSize: 13, fontWeight: 600, padding: '8px 18px', borderRadius: 6, textDecoration: 'none', whiteSpace: 'nowrap' }}>View All Specialties</Link>
        </div>
        <div className="specialties-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 24 }}>
          {specialties.map(item => (
            <Link key={item.id} to={item.link} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', textDecoration: 'none' }}>
              <div style={{ width: 100, height: 100, marginBottom: 10 }}>
                <img src={item.image} alt={item.title} style={{ width: '100%', height: '100%', objectFit: 'contain' }} onError={e => { e.target.style.display = 'none'; }} />
              </div>
              <p style={{ fontSize: 13, fontWeight: 600, color: '#333', lineHeight: 1.4, margin: '0 0 4px' }}>{item.title}</p>
              <span style={{ fontSize: 11, fontWeight: 700, color: '#39a5d3' }}>BOOK NOW</span>
            </Link>
          ))}
        </div>
      </div>

      {/* ── APPOINTMENT CARDS ── */}
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '64px 24px 0' }}>
        <h2 style={{ fontSize: 22, fontWeight: 700, color: '#111', margin: '0 0 6px' }}>Book an appointment for an in-clinic consultation</h2>
        <p style={{ fontSize: 13, color: '#888', margin: '0 0 28px' }}>Find experienced doctors across all specialties</p>
        <div className="appt-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 20 }}>
          {appointmentCards.map(card => (
            <Link key={card.id} to={card.link} style={{ textDecoration: 'none', display: 'block', border: '1px solid #e5e7eb', borderRadius: 12, overflow: 'hidden', background: '#fff', transition: 'box-shadow 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.08)'}
              onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}>
              <div style={{ height: 200, overflow: 'hidden' }}>
                <img src={card.image} alt={card.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={e => { e.target.style.display = 'none'; }} />
              </div>
              <div style={{ padding: '14px 16px 18px' }}>
                <h3 style={{ fontWeight: 700, fontSize: 15, color: '#111', margin: '0 0 4px' }}>{card.title}</h3>
                <p style={{ fontSize: 13, color: '#888', lineHeight: 1.5, margin: 0 }}>{card.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* ── FOR DOCTORS SECTION ── */}
      <div style={{ background: '#f5f7fa', margin: '64px 0', padding: '0' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto', padding: '0 24px' }}>
          <div className="for-doctors-section" style={{ display: 'flex', alignItems: 'stretch', minHeight: 320 }}>
            {/* Left image */}
            <div className="for-doctors-img" style={{ width: '34%', flexShrink: 0, overflow: 'hidden', display: 'flex', alignItems: 'flex-end' }}>
              <img src="/images/35.png" alt="For Doctors" style={{ width: '100%', height: '100%', objectFit: 'contain', objectPosition: 'bottom center', display: 'block' }} onError={e => { e.target.style.display = 'none'; }} />
            </div>
            {/* Right content */}
            <div className="banner-text" style={{ flex: 1, padding: '48px 48px 48px 32px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <p style={{ fontSize: 12, fontWeight: 700, color: '#39a5d3', letterSpacing: 1.5, textTransform: 'uppercase', marginBottom: 12 }}>For Doctors & Clinics</p>
              <h2 className="banner-title" style={{ fontSize: 26, fontWeight: 700, color: '#19354a', lineHeight: 1.3, marginBottom: 14 }}>
                Reach more patients.<br />Build trust that lasts.
              </h2>
              <p style={{ fontSize: 14, color: '#555', lineHeight: 1.75, marginBottom: 24, maxWidth: 420 }}>
                Join Docmize and get discovered by thousands of patients actively looking for a doctor like you.
                We help you build a credible digital presence — with verified profiles, patient reviews,
                and confirmed appointments — so patients come to you with confidence.
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 28 }}>
                {['Verified doctor profile visible to patients', 'Patient reviews that build your reputation', 'Confirmed appointments — no no-shows'].map(point => (
                  <div key={point} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <svg width="16" height="16" viewBox="0 0 18 18" fill="none"><path d="M3 9l4 4 8-8" stroke="#39a5d3" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                    <span style={{ fontSize: 13, color: '#444' }}>{point}</span>
                  </div>
                ))}
              </div>
              <a href="mailto:appointment@docmize.in" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: '#19354a', color: '#fff', borderRadius: 8, padding: '11px 24px', fontSize: 14, fontWeight: 600, textDecoration: 'none', alignSelf: 'flex-start' }}>
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* ── BLOG SECTION ── */}
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '0 24px 80px' }}>
        <div className="blog-section" style={{ display: 'flex', gap: 48, alignItems: 'flex-start' }}>
          <div style={{ minWidth: 240, maxWidth: 280 }}>
            <h2 style={{ fontSize: 24, fontWeight: 700, color: '#111', lineHeight: 1.3, marginBottom: 12 }}>Read top articles from health experts</h2>
            <p style={{ fontSize: 13, color: '#888', lineHeight: 1.7, marginBottom: 24 }}>Health articles that keep you informed about good health practices and help you achieve your goals.</p>
            <Link to="/blog" style={{ display: 'inline-block', background: '#39a5d3', color: '#fff', padding: '11px 24px', borderRadius: 8, fontSize: 14, fontWeight: 600, textDecoration: 'none' }}>See all articles</Link>
          </div>
          <div className="blog-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, flex: 1 }}>
            {[
              { category: 'PREVENTIVE CARE', title: 'How to Choose the Right Doctor for Your Health Needs', author: 'Dr. Anjali Rao', image: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=600&q=80', link: '/blog/preventive-care' },
              { category: 'HEALTHY LIVING', title: '10 Simple Habits That Keep You Healthy All Year Round', author: 'Dr. Sunita Krishnamurthy', image: 'https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=600&q=80', link: '/blog/healthy-habits' },
            ].map((blog, i) => (
              <Link key={i} to={blog.link} style={{ textDecoration: 'none', display: 'block', border: '1px solid #eee', borderRadius: 12, overflow: 'hidden', background: '#fff' }}
                onMouseEnter={e => e.currentTarget.style.boxShadow = '0 6px 24px rgba(0,0,0,0.08)'}
                onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}>
                <div style={{ height: 170, overflow: 'hidden', background: '#f0f4f8' }}>
                  <img src={blog.image} alt={blog.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={e => { e.target.style.display = 'none'; }} />
                </div>
                <div style={{ padding: '14px 16px 18px' }}>
                  <p style={{ fontSize: 11, fontWeight: 700, color: '#39a5d3', letterSpacing: 0.8, marginBottom: 6 }}>{blog.category}</p>
                  <h3 style={{ fontSize: 14, fontWeight: 600, color: '#19354a', lineHeight: 1.4, marginBottom: 10 }}>{blog.title}</h3>
                  <p style={{ fontSize: 12, color: '#888', margin: 0 }}>{blog.author}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>

    </div>
  );
};

export default Homepage;